export default __webpack_public_path__ + "static/media/11.9b2d6f00.svg";